/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: gONO2gG9Ms7Y
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PageLayout from "../../PageLayout"; // plasmic-import: uyj0PXLvMOqU/component
import Container from "../../Container"; // plasmic-import: D1maE2RgYRQ-/component
import PageInfoLine from "../../PageInfoLine"; // plasmic-import: s8ByeseNVHi6/component
import Disclaimer from "../../Disclaimer"; // plasmic-import: 3Ntynz3mbk3J/component
import Footer from "../../Footer"; // plasmic-import: -uu8Ke8fb9WQ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicWorldview.module.css"; // plasmic-import: gONO2gG9Ms7Y/css

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicWorldview__VariantProps = new Array();

export const PlasmicWorldview__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicWorldview__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"pageHome"}
          data-plasmic-override={overrides.pageHome}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_cGVJnrZBpZGCmuty7FxDYj",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.pageHome
          )}
        >
          <div
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("all", sty.sidebar)}
          >
            <div className={classNames("all", "__wab_text", sty.text__kt1Ry)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__ma9Dy
                    )}
                    href={"https://o21p.com/"}
                    platform={"react"}
                  >
                    {"o21p"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" | "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__zy5Vd
                    )}
                    href={`/old-homepage`}
                    platform={"react"}
                  >
                    {"team"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__ygTu7)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__k6Xm4
                    )}
                    href={`/cause`}
                    platform={"react"}
                  >
                    {"cause"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__t0N6W)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link__krc1K
                    )}
                    href={`/the-system-we-build-ourselves`}
                    platform={"react"}
                  >
                    {"our worldview"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div className={classNames("all", "__wab_text", sty.text__vtyhH)}>
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      "all",
                      "a",
                      "a__cGVJn",
                      "__wab_text",
                      "plasmic_default__inline",
                      sty.link___052Ws
                    )}
                    href={`/the-independent`}
                    platform={"react"}
                  >
                    {"the independent"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <PageLayout
            data-plasmic-name={"pageLayout"}
            data-plasmic-override={overrides.pageLayout}
            className={classNames("__wab_instance", sty.pageLayout)}
            content={
              <React.Fragment>
                <section
                  data-plasmic-name={"s00"}
                  data-plasmic-override={overrides.s00}
                  className={classNames("all", sty.s00)}
                >
                  <Container
                    className={classNames(
                      "__wab_instance",
                      sty.container__fFnA
                    )}
                    colContent={
                      <div
                        data-plasmic-name={"freeBox"}
                        data-plasmic-override={overrides.freeBox}
                        className={classNames("all", sty.freeBox)}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__vFpOu
                          )}
                        >
                          {"the system we build ourselves."}
                        </div>
                        <p
                          className={classNames(
                            "all",
                            "p",
                            "p__cGVJn",
                            "__wab_text",
                            sty.p__gtOJp
                          )}
                        >
                          {
                            "How the individual\u2019s relationship to systems is changing, and what becomes possible when they can build their own."
                          }
                        </p>
                      </div>
                    }
                    width={"large"}
                  />
                </section>
                <section
                  data-plasmic-name={"s1"}
                  data-plasmic-override={overrides.s1}
                  className={classNames("all", sty.s1)}
                >
                  <Container
                    className={classNames(
                      "__wab_instance",
                      sty.container__p4Xq0
                    )}
                    colContent={
                      <div
                        data-plasmic-name={"colWrapper"}
                        data-plasmic-override={overrides.colWrapper}
                        className={classNames("all", sty.colWrapper)}
                      >
                        <PageInfoLine
                          className={classNames(
                            "__wab_instance",
                            sty.pageInfoLine__j7EaI
                          )}
                          lineContent={"01. THE CHANGE IN THE WORLD."}
                        />

                        <div
                          data-plasmic-name={"onlyCopyWrapp"}
                          data-plasmic-override={overrides.onlyCopyWrapp}
                          className={classNames("all", sty.onlyCopyWrapp)}
                        >
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__jurqS
                            )}
                          >
                            {"We are entering a new era."}
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p___45Zr0
                            )}
                          >
                            {
                              "An era in which the very infrastructure that built the modern world is showing its limits, and the consequences are now visible in the lives of individuals everywhere."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p___8W0Jd
                            )}
                          >
                            {
                              "For more than a century, society has been organized through large institutions and infrastructures built on industrial logic."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__rlnRr
                            )}
                          >
                            {
                              "Over time, that logic produced a landscape where almost everything that matters in daily life flows through complex systems: how people work, receive care, learn, transact, move, and communicate."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__oOg9W
                            )}
                          >
                            {
                              "Individuals plug into structures they did not design, inherit processes they did not choose, and are measured by metrics they did not set. "
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__e0Bi6
                            )}
                          >
                            {
                              "The promise was efficiency and coordination; the reality is a growing distance between the individual and the forces that shape his or her days."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__x9Vey
                            )}
                          >
                            {
                              "As these systems expanded, they also became denser and more entangled. Layers of software, policy, regulation, and automation accumulate faster than any person can fully understand or meaningfully influence. "
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__hZgb1
                            )}
                          >
                            {
                              "The individual is asked to keep up, to adapt, to absorb change, while the pace and complexity of the surrounding systems keep accelerating."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p___8K4J0
                            )}
                          >
                            {
                              "The effects are familiar: burnout, disengagement, the quiet erosion of meaning in daily work, the sense that one\u2019s role has shifted from practicing a craft or vocation to operating within a machine that never quite fits."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__fYn7
                            )}
                          >
                            {
                              "The systems still function; the individual inside them is increasingly strained."
                            }
                          </p>
                        </div>
                        <PageInfoLine
                          className={classNames(
                            "__wab_instance",
                            sty.pageInfoLine__kHoUu
                          )}
                          lineContent={"02. THE LOGIC THAT NO LONGER WORKS."}
                        />

                        <div
                          data-plasmic-name={"onlyCopyWrapp2"}
                          data-plasmic-override={overrides.onlyCopyWrapp2}
                          className={classNames("all", sty.onlyCopyWrapp2)}
                        >
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__kgNlE
                            )}
                          >
                            {
                              "Industrial logic is a way of designing systems where the function is throughput: more output, more predictably, at lower cost. It optimizes for standardization, control, and repetition, treating individuals as interchangeable units inside a larger process."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__y3PXq
                            )}
                          >
                            {
                              "This approach is entirely appropriate for tasks such as stamping metal, moving crates, or basic assembly, domains where variance is harmful and judgment is minimal."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__gedis
                            )}
                          >
                            {
                              "But much of human work has never functioned that way. The value comes from judgment, empathy, interpretation, and contextual reasoning, qualities that cannot be standardized without degrading the work itself."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__yXj1G
                            )}
                          >
                            {
                              "Industrial logic takes living, contextual work and forces it into procedures that people are only allowed to operate. It replaces the craft with the workflow, the practitioner with the operator."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__jKlcW
                            )}
                          >
                            {
                              "This displacement began with the first factories, but today it has scaled to a different magnitude. Modern systems are no longer simple or stable; they are layered, abstract, and continuously changing. Software, regulation, automation, and platforms build on top of one another, updating faster than any individual can meaningfully adapt. "
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__iRXqG
                            )}
                          >
                            {
                              "Industrial logic reacts in the only way it can: by tightening control and further constraining human discretion."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__wl6V5
                            )}
                          >
                            {
                              "The result is a structural mismatch the individual can\u2019t overcome by effort alone. The person is pushed away from the substance of their work and outpaced by the systems that govern it. What was once alienation has become overwhelm."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__n4R1E
                            )}
                          >
                            {
                              "Industrial logic may still \u201cwork\u201d for institutions measured in throughput and efficiency, but it no longer works for human beings whose work depends on judgment, agency, and meaning."
                            }
                          </p>
                        </div>
                        <PageInfoLine
                          className={classNames(
                            "__wab_instance",
                            sty.pageInfoLine___5Uh6X
                          )}
                          lineContent={"03. AMPLIFICATION OVER AUTOMATION."}
                        />

                        <div
                          data-plasmic-name={"onlyCopyWrapp3"}
                          data-plasmic-override={overrides.onlyCopyWrapp3}
                          className={classNames("all", sty.onlyCopyWrapp3)}
                        >
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p___0Foy1
                            )}
                          >
                            {
                              "In the current paradigm, automation is treated as the primary answer to rising complexity. Systems are designed to remove as much human involvement as possible from critical flows. Within this frame, the individual is positioned as a replaceable executor of tasks defined elsewhere\u2014a resource whose function is to convert instructions, protocols, and inputs into outputs according to the system\u2019s design."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__aXcD
                            )}
                          >
                            {
                              "Taken to its logical conclusion, this approach does not merely streamline work; it makes the presence of the individual optional."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__baqlk
                            )}
                          >
                            {
                              "As processes become more formalized and machine-executable, the human role can be minimized and, eventually, substituted by artificial processes that replicate the same inputs and outputs."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__zeygl
                            )}
                          >
                            {
                              "The individual is not asked to exercise judgment, but to conform to a role that can, in principle, be automated away."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__swIeN
                            )}
                          >
                            {
                              "Yet the underlying problem remains: human capacity does not scale at the same rate as system complexity. Simply removing humans from more steps does not resolve the mismatch; it shifts it elsewhere and narrows the domain in which human judgment can operate. The question is not whether tasks can be automated, but what principle should govern the relationship between human capability and complex systems."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__cByH
                            )}
                          >
                            {"The alternative principle is amplification."}
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__oTRqr
                            )}
                          >
                            {
                              "Instead of designing systems to replace the individual, systems guided by the principle of amplification are designed to extend and amplify the individual\u2019s ability. Automation is used selectively\u2014to offload repetition, reduce cognitive load, and manage scale\u2014so that judgment, interpretation, and initiative can be applied where they matter most. The individual remains the source of decision and meaning; the environment around them is re-architected to give their abilities more reach."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__zaZI
                            )}
                          >
                            {
                              "If human capacity cannot scale, then leverage is required\u2014not in the form of substituting the human, but by reshaping the environment in which the human operates. Amplification over automation is the principle that makes this possible."
                            }
                          </p>
                        </div>
                        <PageInfoLine
                          className={classNames(
                            "__wab_instance",
                            sty.pageInfoLine__lwaAu
                          )}
                          lineContent={"04. PERSONAL SYSTEMS."}
                        />

                        <div
                          data-plasmic-name={"onlyCopyWrapp4"}
                          data-plasmic-override={overrides.onlyCopyWrapp4}
                          className={classNames("all", sty.onlyCopyWrapp4)}
                        >
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__lDwSb
                            )}
                          >
                            {
                              "A principle on its own is not enough. If amplification is to be more than an intention, it needs a concrete architectural form\u2014a way for individuals to organize tools, information, and collaboration around their own judgment."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p___66Pd
                            )}
                          >
                            {"That form is personal systems."}
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p___2BNwU
                            )}
                          >
                            {
                              "A personal system is the invisible infrastructure an individual builds around their work and life to extend what they can do in a complex world. It is not a single app or platform, but a composed environment: tools, workflows, data, and agents arranged in a way that reflects the individual\u2019s priorities, style of thinking, and responsibilities. The function of a personal system is to give the individual leverage without requiring them to surrender autonomy."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__mWxZk
                            )}
                          >
                            {
                              "This stands in contrast to industrial-era architectures, where systems are designed from the top down and individuals are assigned fixed roles within them. In those structures, the person adapts to the workflow; judgment is constrained by what the system anticipates. In a personal system, the direction is reversed: tools and processes are selected, combined, and reshaped to fit the way the individual needs to operate."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__rraDf
                            )}
                          >
                            {
                              "Personal systems share a few defining characteristics. They are modular, allowing components to be added, removed, or reconfigured without starting over. They are interconnected, so information can move where it is needed without trapping the individual in one vendor\u2019s logic. They are adaptive, evolving as the person\u2019s work, context, and ambitions change. Above all, they are person-centered: the organizing principle is the individual\u2019s judgment, not institutional efficiency."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__hvCdj
                            )}
                          >
                            {
                              "In this sense, a personal system marks a shift in the individual\u2019s structural role. The individual is no longer just an operator within someone else\u2019s environment, but a node with their own infrastructure\u2014a center of agency capable of participating in larger ecosystems without being absorbed by them."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__obT0Z
                            )}
                          >
                            {
                              "Personal systems are the architectural expression of amplification over automation: they make it possible for individuals to act as themselves, at greater scale, inside an increasingly complex world."
                            }
                          </p>
                        </div>
                        <PageInfoLine
                          className={classNames(
                            "__wab_instance",
                            sty.pageInfoLine__p0EAz
                          )}
                          lineContent={"05. THE COLLECTIVE WORK AHEAD."}
                        />

                        <div
                          data-plasmic-name={"onlyCopyWrapp5"}
                          data-plasmic-override={overrides.onlyCopyWrapp5}
                          className={classNames("all", sty.onlyCopyWrapp5)}
                        >
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__vjfPw
                            )}
                          >
                            {
                              "As the world transitions into a new era, the individual is stripped of autonomy\u2014the foundation of meaningful human action. When people can no longer influence the systems they depend on, the conditions for a real, unique identity begin to disappear. Human identity is not built from roles assigned inside a hierarchy; it is built from choices\u2014what to do, what to value, what to refuse. As more of life is routed through structures that predefine roles, options, and responses, individuals are treated less as agents and more as subsystems."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__k2JuL
                            )}
                          >
                            {
                              "In such an environment, systems dictate pace; pace shapes behavior; behavior, repeated over time, shapes meaning. The less say individuals have in how these systems work, the more their capacity, creativity, and ethical judgment erode. When the infrastructures people rely on are designed without them, agency is gradually absorbed. People are asked to comply rather than to create, and over time they stop seeing themselves as authors of anything. A society in which individuals no longer have the space to act as creators is one that is slowly running out of life."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__rfzl5
                            )}
                          >
                            {
                              "At the same time, the conditions for a different architecture are beginning to exist. The cost of creating and combining tools has fallen. Interoperable standards and programmable infrastructure are becoming more widely available. New forms of automation make it possible to offload entire layers of complexity that once required institutional scale. For the first time, the ingredients for amplification at the level of the individual are within reach."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__v5F1H
                            )}
                          >
                            {
                              "The alternative is deliberate work: designing environments in which individuals can construct and evolve their own infrastructure, rather than inheriting it entirely from above. This requires technical foundations that are modular and interoperable, but it also requires a shift in how creators, organizations, and collaborators understand their role. Tools, services, and systems must be offered in ways that can be composed into personal systems, not only embedded into institutional ones."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__ijxHz
                            )}
                          >
                            {
                              "The responsibility is therefore shared. Individuals can no longer be asked only to subscribe to or fit into existing structures; they must be given the means to build structures of their own. Technologists and system designers must treat amplification and the autonomy the individual retains as the primary measures of progress. Organizations that depend on human judgment must recognize that when autonomy is eroded, the quality of that judgment erodes with it."
                            }
                          </p>
                          <p
                            className={classNames(
                              "all",
                              "p",
                              "p__cGVJn",
                              "__wab_text",
                              sty.p__lDdG
                            )}
                          >
                            {
                              "We imagine a world in which the individual lives and works on their own terms, preserving their autonomy and identity within increasingly complex systems. Personal systems are the infrastructure through which this becomes possible. The work ahead is to bring that infrastructure into existence and to place it, by design, in the hands of the individual."
                            }
                          </p>
                        </div>
                      </div>
                    }
                    width={"large"}
                  />
                </section>
              </React.Fragment>
            }
            layoutSections={"withNav"}
          />

          <section
            data-plasmic-name={"s999"}
            data-plasmic-override={overrides.s999}
            className={classNames("all", sty.s999)}
          >
            <Disclaimer
              data-plasmic-name={"disclaimer"}
              data-plasmic-override={overrides.disclaimer}
              className={classNames("__wab_instance", sty.disclaimer)}
            />

            <Footer
              data-plasmic-name={"footer"}
              data-plasmic-override={overrides.footer}
              className={classNames("__wab_instance", sty.footer)}
              layout={"withOffset"}
              sectionId={"footer"}
            />
          </section>
          <div
            data-plasmic-name={"noBudgetSmallScreens"}
            data-plasmic-override={overrides.noBudgetSmallScreens}
            className={classNames("all", sty.noBudgetSmallScreens)}
          >
            <div className={classNames("all", "__wab_text", sty.text__vA5Vq)}>
              {"o21p"}
            </div>
            <div className={classNames("all", "__wab_text", sty.text__ivCm)}>
              {
                "our massive development budget is dedicated to designing and building the platform for larger screens."
              }
            </div>
            <div className={classNames("all", "__wab_text", sty.text__baErr)}>
              {"\u2013 at least 900px wide \u2013"}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageHome: [
    "pageHome",
    "sidebar",
    "pageLayout",
    "s00",
    "freeBox",
    "s1",
    "colWrapper",
    "onlyCopyWrapp",
    "onlyCopyWrapp2",
    "onlyCopyWrapp3",
    "onlyCopyWrapp4",
    "onlyCopyWrapp5",
    "s999",
    "disclaimer",
    "footer",
    "noBudgetSmallScreens"
  ],

  sidebar: ["sidebar"],
  pageLayout: [
    "pageLayout",
    "s00",
    "freeBox",
    "s1",
    "colWrapper",
    "onlyCopyWrapp",
    "onlyCopyWrapp2",
    "onlyCopyWrapp3",
    "onlyCopyWrapp4",
    "onlyCopyWrapp5"
  ],

  s00: ["s00", "freeBox"],
  freeBox: ["freeBox"],
  s1: [
    "s1",
    "colWrapper",
    "onlyCopyWrapp",
    "onlyCopyWrapp2",
    "onlyCopyWrapp3",
    "onlyCopyWrapp4",
    "onlyCopyWrapp5"
  ],

  colWrapper: [
    "colWrapper",
    "onlyCopyWrapp",
    "onlyCopyWrapp2",
    "onlyCopyWrapp3",
    "onlyCopyWrapp4",
    "onlyCopyWrapp5"
  ],

  onlyCopyWrapp: ["onlyCopyWrapp"],
  onlyCopyWrapp2: ["onlyCopyWrapp2"],
  onlyCopyWrapp3: ["onlyCopyWrapp3"],
  onlyCopyWrapp4: ["onlyCopyWrapp4"],
  onlyCopyWrapp5: ["onlyCopyWrapp5"],
  s999: ["s999", "disclaimer", "footer"],
  disclaimer: ["disclaimer"],
  footer: ["footer"],
  noBudgetSmallScreens: ["noBudgetSmallScreens"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWorldview__ArgProps,
          internalVariantPropNames: PlasmicWorldview__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWorldview__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageHome") {
    func.displayName = "PlasmicWorldview";
  } else {
    func.displayName = `PlasmicWorldview.${nodeName}`;
  }
  return func;
}

export const PlasmicWorldview = Object.assign(
  // Top-level PlasmicWorldview renders the root element
  makeNodeComponent("pageHome"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    pageLayout: makeNodeComponent("pageLayout"),
    s00: makeNodeComponent("s00"),
    freeBox: makeNodeComponent("freeBox"),
    s1: makeNodeComponent("s1"),
    colWrapper: makeNodeComponent("colWrapper"),
    onlyCopyWrapp: makeNodeComponent("onlyCopyWrapp"),
    onlyCopyWrapp2: makeNodeComponent("onlyCopyWrapp2"),
    onlyCopyWrapp3: makeNodeComponent("onlyCopyWrapp3"),
    onlyCopyWrapp4: makeNodeComponent("onlyCopyWrapp4"),
    onlyCopyWrapp5: makeNodeComponent("onlyCopyWrapp5"),
    s999: makeNodeComponent("s999"),
    disclaimer: makeNodeComponent("disclaimer"),
    footer: makeNodeComponent("footer"),
    noBudgetSmallScreens: makeNodeComponent("noBudgetSmallScreens"),
    // Metadata about props expected for PlasmicWorldview
    internalVariantProps: PlasmicWorldview__VariantProps,
    internalArgProps: PlasmicWorldview__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/the-system-we-build-ourselves",
      pagePath: "/the-system-we-build-ourselves",
      params: {},
      query: {}
    })
  }
);

export default PlasmicWorldview;
/* prettier-ignore-end */
